export default {
	"billConfirm": {
		"PackingQty": "货品数量",
		"settlementStatus": "结算状态",
		"keywords": "关键词",
		"isConfirm": "是否确认",
		"isAdjust": "是否调整",
		"isAbnormal": "是否异常",
		"billPrice": "金额",
		"routeBill": "派车单计费",
		"billconfirmdeliverVehicleType": "操作类型",
		"fixWorkAmount": "当前业务量",
		"serviceDepartment": "作业单位",
		"billingAmount": "计费量",
		"billingResource": "计费来源",
		"correctionItemsTitle": "运单作业数据修正",
		"errorMessageTips": "错误提示"
	},
	"billReconciliation": {
		"printHandleDetail": "打印明细",
		"chooseBillTips": "选择账单中要输出的数据",
		"sendWeight": "实发重量",
		"receiptWeight": "实收重量",
		"locationNumber": "地点数",
		"billPrinting": "账单打印",
		"addPartner": "添加伙伴",
		"addSize": "添加站点",
		"addUser": "新增人员",
		"addRoles": "角色添加",
		"printDataChooseTips": "请勾选打印数据"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/billPayable/billPayable.js